import type React from "react"
import { PostTagFilter } from "@/components/community/PostTagFilter"
import { PostList } from "@/components/community/PostList"
import { WriteFab } from "@/components/community/WriteFab"
import "./CommunityPage.css"

const CommunityPage: React.FC = () => {
  return (
    <div className="community-page">
      <header className="community-header">
        <h1>커뮤니티</h1>
      </header>
      
      <PostTagFilter />
      
      <main className="community-content">
        <PostList />
      </main>
      
      <WriteFab />
    </div>
  )
}

export default CommunityPage
